$(() => {
    jQuery.fn.scrollTo = function(elem, spread, speed) {
        $(this).animate(
            {
                scrollTop:
                    $(this).scrollTop() - $(this).offset().top + $(elem).offset().top - spread,
            },
            speed == undefined ? 500 : speed,
        )
        return this
    }

    $('.wheel-picker .select-block ul li').click(function(e) {
        e.preventDefault()
        var el = $(this)
        var parent = el.parent('ul')
        var elClass = el.attr('class').split(' ')[0]

        var parentH = parent.innerHeight()
        var elH = el.height()

        var spread = parentH / 2 - elH / 2
        parent.scrollTo('.' + elClass, spread)
    })
})
